var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NextPrevArticle',{attrs:{"prev":_vm.p.PrevArticle,"next":_vm.p.NextArticle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }